// extracted by mini-css-extract-plugin
export default {"adminmenu":"AdminMenu_adminmenu__m2qFi","background":"AdminMenu_background__4N5MA","AdminOptions":"AdminMenu_AdminOptions__Oc5cc"};